import loadable from '@loadable/component';

export const RateRecommendedCandidateLoadable = loadable(
  () => import('./RateRecommendedCandidate'),
  { resolveComponent: (module) => module.RateRecommendedCandidate },
);
